import { httpFetch } from './httpTransport';
import { sequenceWrite,isMediaPreparation } from './dataSync';
import { getSupplierToken, clearSupplierSession } from '../features/supplier/supplierAccess';
import { readSessionKey } from './queryCache';
import { prepareImportForm } from './importUpload';

/** One transport for the ERP, catalog and supplier team session. Never retries writes. */
export async function teamFetch(input: string, init: RequestInit | undefined, networkError: () => Error): Promise<Response> {
    if(init?.body instanceof FormData) init={...init,body:await prepareImportForm(input,init.body,init.signal??undefined)};
    return sequenceWrite(input, init, async () => {
        const scope = readSessionKey();
        const supplierSession = localStorage.getItem('supplier_portal_session');
        const url = new URL(input, window.location.origin);
        if (!['GET', 'HEAD', 'OPTIONS'].includes((init?.method ?? 'GET').toUpperCase())) {
            if (!isMediaPreparation(input,init)&&/\/erp\/(livestreams|procurements)(?:\/|$)/.test(url.pathname)) url.searchParams.set('_sync', '1');
            if (/\/supplier\/(products|suppliers|orders)(?:\/|$)/.test(url.pathname)) url.searchParams.set('view', 'fields');
        }
        const target = input.startsWith('/') && !input.startsWith('//') ? `${url.pathname}${url.search}${url.hash}` : url.toString();
        const headers = new Headers(init?.headers);
        const token = getSupplierToken();
        if (token && !headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
        let response: Response;
        try { response = await httpFetch(target, {...init, headers}); }
        catch (error) {
            if (error instanceof Error && error.name === 'AbortError') throw error;
            throw networkError();
        }
        if (scope !== readSessionKey()) throw new DOMException('Session changed', 'AbortError');
        if (response.status === 401 && supplierSession) {
            clearSupplierSession();
            window.dispatchEvent(new Event('supplierAuthExpired'));
        }
        return response;
    });
}
